var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 13.333H16.0001C15.6465 13.333 15.3073 13.4735 15.0573 13.7235C14.8072 13.9736 14.6667 14.3127 14.6667 14.6663V25.333C14.6667 25.6866 14.8072 26.0258 15.0573 26.2758C15.3073 26.5259 15.6465 26.6663 16.0001 26.6663H24.0001C24.3537 26.6663 24.6928 26.5259 24.9429 26.2758C25.1929 26.0258 25.3334 25.6866 25.3334 25.333V16.6663L22.0001 13.333Z",
    stroke: "#09090B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 13.333V15.9997C21.3333 16.3533 21.4737 16.6924 21.7238 16.9425C21.9738 17.1925 22.313 17.333 22.6666 17.333H25.3333",
    stroke: "#09090B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 18H17.3333",
    stroke: "#09090B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 20.667H17.3333",
    stroke: "#09090B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 23.333H17.3333",
    stroke: "#09090B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.9dd034fa02bbc3eca96a59dcb7492cbc.svg";
export { ForwardRef as ReactComponent };